import {Message} from 'element-ui'
import {MessageBox} from 'element-ui'
import Constant from '../utils/constant'

let removeItem = function (api, params, callback) {
    MessageBox.confirm('确认删除操作？', '操作提示').then(() => {
        api.apply(this, [params, res => {
            try {
                if (res.data.status == 'success') {
                    Message({
                        type: 'success',
                        message: '删除成功！'
                    })
                } else {
                    Message({
                        type: 'error',
                        message: '删除失败！'
                    })
                }
                callback.apply(this, [res])
            } catch (e) {

            }
        }])
    }).catch(() => {
        Message.info('取消删除操作')
    })
}

let getImageUrl = function (imageId, size = '', ext = '.PNG') {
    return imageId ? Constant.SERVER_BASE_URL + '/images/' + imageId.replace('images/', '') + (size ? '-' + size : '') + ext
        :
        require('../assets/images/noImage.gif')
}

let getFileUrl = function (fileId = '', size = null, ext = '.PNG') {
    if ( (fileId||'').indexOf('https://') !== -1 || (fileId||'').indexOf('http://') !== -1 ) {
        return fileId
    }
    else {
        return fileId ?
            (
                Constant.SERVER_BASE_URL + '/files/' + fileId.replace('files/', '') +
                (size ? '/' + size + ext : '/!/')
            )
            :
            require('../assets/images/noImage.gif')
    }
}

let xmlBuildQuery = function (filters) {
    return filters.columns.reduce((obj, item) => {
        let dataField = item.field.replace('__', '.')
        let value = filters.form[item.field]


        if (dataField == item.field) return obj

        if (Array.isArray(value)) {
            let op = item.op || ['gteq', 'lteq']
            let dateFormat = item.dateFormat || []

            try {
                value.forEach((item, index) => {
                    if (typeof item != 'undefined') {
                        obj['xlist.search.' + dataField + '[' + index + ']'] = value[index]
                        obj['xlist.search.' + dataField + '[' + index + ']' + '.dateformat'] = dateFormat[index] || 'yyyy-MM-dd HH:mm:ss'
                        obj['xlist.search.' + dataField + '[' + index + ']' + '.op'] = op[index]
                    }
                })

            } catch (e) {

            }
        } else {
            if (filters.form[item.field]) {
                obj['xlist.search.' + dataField] = filters.form[item.field] || ''
                obj['xlist.search.' + dataField + '.op'] = item.op || 'like'
            }
        }

        return obj
    }, {})
}

const xmlBuildSort = function (sortParams = {}) {
    return Object.keys(sortParams).reduce((total, curr) => {
        total['xlist.sort.dataField'] = curr
        total['xlist.sort.order'] = sortParams[curr].replace('ending', '')

        return total
    }, {})
}
export {
    removeItem,
    getImageUrl,
    getFileUrl,
    xmlBuildQuery,
    xmlBuildSort
}



// WEBPACK FOOTER //
// ./src/filters/CommonActions.js